import { useEffect } from 'react';

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

export const GoogleAnalytics = () => {
  useEffect(() => {
    if (!GA_ID || typeof window === 'undefined') return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    const gtag = (...args: unknown[]) => {
      window.dataLayer.push(args);
    };
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, { anonymize_ip: true });

    return () => {
      script.remove();
    };
  }, []);

  return null;
};

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}
